const registerStaffEN = {
	step: "Step {{step}} of 3",

	step1: {
		title: "Create An Account",
		email: "Email",
		firstName: "First name",
		lastName: "Last name",
		phone: "Phone number",
		password: "Password",
		confirmPassword: "Confirm Password",
		remember: "Remember me",
		register: "Register",
		registering: "Registering...",
	},

	step2: {
		title: "Register Your Shop",
		shopName: "Shop name",
		address: "Address",
		city: "City",
		country: "Country",
		postalCode: "Postal Code",
		description: "Description",
		category: "Business Type",
		openingHours: "Opening Hours",
		closed: "Closed",
		socials: "Social Media Links",
		instagram: "Instagram URL",
		facebook: "Facebook URL",
		tiktok: "TikTok URL",
		website: "Website URL",
		next: "Next step",
		registering: "Registering...",
	},

	step3: {
		title: "Add Services",
		description: "Add at least one service to finish your setup.",
		photos: "Portfolio Photos",
		upload: "Upload Photos",
		finish: "Finish Setup",
		registering: "Registering...",
	},

	errors: {
		fillRequired: "Please fill in all required fields.",
		passwordMatch: "Passwords do not match.",
		uploadImages: "Please upload at least one photo before finishing setup.",
		invalidInvite: "Invalid or expired invite link.",
		mustAcceptTerms: "You must accept the Terms & Conditions to continue.",

	},

	success: {
		adminCreated: "Admin created successfully — now set up your shop.",
		returning: "Welcome back! Continue registering your shop.",
	},

	days: {
		Monday: "Monday",
		Tuesday: "Tuesday",
		Wednesday: "Wednesday",
		Thursday: "Thursday",
		Friday: "Friday",
		Saturday: "Saturday",
		Sunday: "Sunday",
	},
};

export default registerStaffEN;
